import React, { useEffect } from 'react';

import Contact from '../../Components/Contact/Contact'
import './contactpage.scss'

function ContactPage() {
    useEffect(() => {
        document.title = 'Aprameya Shankar : Contact';
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.scrollTo(0, 0);
    });

  return (
    <><div className='noise-div'></div>
        <div id='contact-page-container'>
           <Contact /> 
        </div>        
    </>
  )
}

export default ContactPage